<label for="">Tags</label>
<ng-select
  [items]="tagSvc.formattedRecord$ | async"
  bindValue="id"
  [searchFn]="customTagsSearchFn"
  [(ngModel)]="value"
  (change)="onChange()"
  multiple="true"
  [loading]="tagSvc.gettingRecords"
>
  <ng-template ng-label-tmp let-item="item" let-clear="clear">
    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true"
      >×</span
    >
    <span [innerHTML]="item.rawName" class="d-inline"></span>
  </ng-template>
  <ng-template
    ng-option-tmp
    let-item="item"
    let-index="index"
    let-search="searchTerm"
  >
    <h6 [innerHTML]="item.name"></h6>
  </ng-template>
</ng-select>
